// List of rows needing attention; click a row to filter the grid to it.

import { useTranslation } from 'react-i18next';
import {
  fieldLabel,
  translateIssueMessage,
} from '~/pages/inventory-import/lib/fieldLabel';
import type { RowReport } from '~/pages/inventory-import/lib/validate';

export function IssuesPanel({
  reports,
  onJump,
}: {
  reports: RowReport[];
  onJump: (rowId: number) => void;
}) {
  const { t } = useTranslation('inventory-import');
  if (reports.length === 0) return null;
  return (
    <div className="max-h-44 overflow-auto rounded-lg border border-neut-border bg-neut-bg-alt p-2 text-sm shadow-sm">
      <p className="mb-1 font-medium text-neut-prim">
        {t('issues.need_attention', { count: reports.length })}
      </p>
      <ul className="flex flex-col gap-0.5">
        {reports.slice(0, 200).map((rep) => {
          const hasError = rep.issues.some((i) => i.level === 'error');
          return (
            <li key={rep.rowId}>
              <button
                type="button"
                onClick={() => onJump(rep.rowId)}
                className="flex w-full items-start gap-1.5 rounded px-1.5 py-1 text-left hover:bg-neut-hover"
              >
                <span
                  className={`mt-1 inline-block h-2.5 w-2.5 shrink-0 rounded-full ${
                    hasError ? 'bg-error-500' : 'bg-warning-500'
                  }`}
                  role="img"
                  aria-label={
                    hasError ? t('issues.error_aria') : t('issues.warning_aria')
                  }
                />
                <span>
                  <span className="font-medium text-neut-prim">
                    {t('issues.row', { id: rep.rowId })}
                  </span>{' '}
                  <span className="text-neut-sec">
                    {rep.issues
                      .map(
                        (i) =>
                          `${fieldLabel(t, i.field)}: ${translateIssueMessage(t, i.messageKey, i.params)}`
                      )
                      .join(' · ')}
                  </span>
                </span>
              </button>
            </li>
          );
        })}
      </ul>
      {reports.length > 200 && (
        <p className="mt-1 text-xs text-neut-sec">
          {t('issues.and_more', { count: reports.length - 200 })}
        </p>
      )}
    </div>
  );
}
